import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, Col, DatePicker, Input, message, Modal, Row, Select, Space, Upload } from "antd"
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons'
import { baseAxiosComplete, baseAxiosNoInfo } from "../../../tool/axios"
import { apiPrefix } from "../../../js/config"
import _ from 'lodash'

const { Option } = Select

interface reciveRow {
    other_goods_type_id: undefined | string // 商品分类标识
    other_goods_id: undefined | string // 商品标识
    num: undefined | number, // 商品数量
    pay_date: undefined | string, // 付款日期
    pay_code: undefined | string, // 付款单号
    pay_way: undefined | number, // 付款方式
    amount: undefined | string, // 付款金额
    pay_prov_pic_list: undefined | string[], // 付款凭证集合
    remark: undefined | string
}

interface Prop {
    storeID?: string
}

const upLoadProps = {
    name: 'files',
    data: { fileType: 1, bucketType: 4 },
    action: apiPrefix + '/global/upload_pic',
}

export default function (prop: Prop) {

    const param: { id: string } = useParams()

    const [visible, setVisible] = useState<boolean>(false)

    const [types, setTypes] = useState<{
        other_goods_type_id: string
        other_goods_type_name: string
    }[]>([])

    const [goods, setGoods] = useState<{
        other_goods_id: string
        other_goods_name: string
    }[]>([])

    let reciveMoneyRow: reciveRow = {
        other_goods_type_id: undefined,
        other_goods_id: undefined,
        num: undefined,
        pay_date: undefined,
        pay_code: undefined,
        pay_way: undefined,
        amount: undefined,
        pay_prov_pic_list: [],
        remark: undefined
    }

    const [reciveMoneyData, setReciveMoneyData] = useState<reciveRow[]>([{
        other_goods_type_id: undefined,
        other_goods_id: undefined,
        num: undefined,
        pay_date: undefined,
        pay_code: undefined,
        pay_way: undefined,
        amount: undefined,
        pay_prov_pic_list: [],
        remark: undefined
    }])

    const addMoreRow = () => {
        setReciveMoneyData([...reciveMoneyData, reciveMoneyRow])
    }

    const deleteRow = (index: number) => {
        if (reciveMoneyData.length > 1) {
            let reciveD = _.cloneDeep(reciveMoneyData)
            reciveD.splice(index, 1)

            setReciveMoneyData(reciveD)
        }
    }

    const handleChange = (index: number, attr: string, value: any) => {
        let reciveD: any = _.cloneDeep(reciveMoneyData)
        reciveD[index][attr] = value

        setReciveMoneyData(reciveD)
    }

    const uploadChange = (info: any, index: number) => {
        let reciveD: any = _.cloneDeep(reciveMoneyData)

        if (info.file.status === 'done') {
            message.success(`${info.file.name} 上传成功`)
            reciveD[index].pay_prov_pic_list.push(info.file.response.data[0])

            setReciveMoneyData(reciveD)

        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed.`);

        } else if (info.file.status === 'removed') {
            let i = reciveD[index].pay_prov_pic_list.findIndex((el: string) => el === info.file.response.data[0])
            reciveD[index].pay_prov_pic_list.splice(i, 1)

            setReciveMoneyData(reciveD)
        }
    }

    useEffect(() => {
        baseAxiosNoInfo('/global/other_goods_type_list').then((res: any) => {
            res && setTypes(res)
        })
    }, [])

    const onFinish = () => {
        baseAxiosComplete.post('/keeper/check_in/detail/add_other_pay', {
            check_in_id: param.id,
            pay_detail: reciveMoneyData
        }).then(res => {
            if (res.status === 0) {
                message.success(`录入成功`)
                setVisible(false)
            }
        })
    }

    return <Fragment>
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 录入其他收入 */}
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>录入其他收入</Button>

        <Modal title="录入其他收入" width={1500} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <Row style={{ marginBottom: 16 }} gutter={8} justify="space-around">
                <Col span={2}>收款日期</Col>
                <Col span={2}>商品分类</Col>
                <Col span={2}>商品</Col>
                <Col span={2}>数量</Col>
                <Col span={2}>收款金额</Col>
                <Col span={2}>收款方式</Col>
                <Col span={2}>收款单号</Col>
                <Col span={2}>收款凭证</Col>
                <Col span={2}>备注</Col>
                <Col span={1}></Col>
            </Row>

            {reciveMoneyData.map((el, index: number) => <Row gutter={8} justify="space-around" style={{ marginBottom: 8, userSelect: 'none' }}>
                <Col span={2}>
                    <DatePicker onChange={(v: any) => {
                        handleChange(index, 'pay_date', v.format('YYYY-MM-DD'))
                    }} />
                </Col>
                <Col span={2}>
                    <Select value={el.other_goods_type_id} style={{ width: '100%' }} onChange={(v: string) => {
                        handleChange(index, 'other_goods_type_id', v)
                        baseAxiosNoInfo('/global/other_goods_list', {
                            params: {
                                store_id: prop.storeID,
                                other_goods_type_id: v
                            }
                        }).then((res: any) => {
                            setGoods(res)
                        })
                    }}>
                        {types.map(el => <Option key={el.other_goods_type_id} value={el.other_goods_type_id}>{el.other_goods_type_name}</Option>)}
                    </Select>
                </Col>
                <Col span={2}>
                    <Select value={el.other_goods_id} style={{ width: '100%' }} onChange={(v: string) => {
                        handleChange(index, 'other_goods_id', v)
                    }}>
                        {goods.map(el => <Option key={el.other_goods_id} value={el.other_goods_id}>{el.other_goods_name}</Option>)}
                    </Select>
                </Col>

                <Col span={2}>
                    <Input placeholder="数量" style={{ width: '100%' }} value={el.num} onChange={(v: any) => {
                        if (isNaN(Number(v.target.value))) {
                            message.error('必须是数字')
                        } else {
                            handleChange(index, 'num', v.target.value)
                        }
                    }} />
                </Col>
                <Col span={2}>
                    <Input placeholder="金额" style={{ width: '100%' }} value={el.amount} onChange={(v: any) => {
                        if (isNaN(Number(v.target.value))) {
                            message.error('必须是数字')
                        } else {
                            handleChange(index, 'amount', v.target.value)
                        }
                    }} />
                </Col>
                <Col span={2}>
                    <Select value={el.pay_way} style={{ width: '100%' }} onChange={(v: number) => {
                        handleChange(index, 'pay_way', v)
                    }}>
                        <Option key={1} value={1}>现金</Option>
                        <Option key={2} value={2}>支付宝</Option>
                        <Option key={3} value={3}>微信</Option>
                        <Option key={4} value={4}>银联卡</Option>
                        <Option key={5} value={5}>押金抵扣</Option>
                        <Option key={6} value={6}>小精灵</Option>
                        <Option key={7} value={7}>对公转账</Option>
                    </Select>
                </Col>
                <Col span={2}>
                    <Input style={{ width: '100%' }} value={el.pay_code} onChange={(v) => {
                        handleChange(index, 'pay_code', v.target.value)
                    }} />
                </Col>
                <Col span={2} style={{ paddingTop: 4 }}>
                    <Space>
                        <Upload  {...upLoadProps} onChange={(info: any) => {
                            uploadChange(info, index)
                        }}>
                            <Button icon={<UploadOutlined />} size="small" ></Button>
                        </Upload>
                    </Space>
                </Col>
                <Col span={2}>
                    <Input style={{ width: '100%' }} value={el.remark} onChange={(v) => {
                        handleChange(index, 'remark', v.target.value)
                    }} />
                </Col>

                <Col span={1} style={{ paddingTop: 4 }}>
                    <DeleteOutlined onClick={() => {
                        deleteRow(index)
                    }} style={{ cursor: 'pointer' }} />
                </Col>
            </Row>)}

            <Button onClick={addMoreRow} style={{ marginTop: 16 }} size="small" type="primary">添加收款</Button>
        </Modal>
    </Fragment>
}